/*eslint eqeqeq: "off"*/
// React
import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

// Redux
import { compose } from 'redux';

// React device detect
// import { isMobile } from 'react-device-detect';

//Actions
import {
    loadPagePayments,
} from '../actions/PaymentsActions';



import { changeSignUpLoginModal, changeClickType, setUrlRedirect } from 'app/authentication/actions/LoginActionsCreators';

//Components
import PaymentsBillsToPayComponent from '../components/payments-bills-to-pay/PaymentsBillsToPayComponent';

// Styles
import './PaymentsView.styles.css';



class PaymentsUnauthenticatedView extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {

        };
    }

    
    componentDidMount() {
        this.props.loadPagePayments( this.props.match.params.pagename );
    }
    componentDidUpdate(prevProps){
        if(prevProps.match.params.pagename !== this.props.match.params.pagename){
            this.props.loadPagePayments( this.props.match.params.pagename );
        }
    }

    async handleOnPayment( payment ){

        //Para abrir modal de redireccion de acceso
        this.props.changeSignUpLoginModal(true);
        this.props.changeClickType('pagePaymentLocked');
        let url_redirect = `?league/${this.props.match.params.pagename}/payments`;
        this.props.setUrlRedirect(url_redirect);
    }

    render() {
        return (
            <div className='payments-unauth'>
                <div className="payments__center-container">
                                       

                    <PaymentsBillsToPayComponent
                        page_payments_list={this.props.state.payments.page_payments_list}
                        handleOnPayment={ ( payment )=>{ this.handleOnPayment( payment ) }}
                        loadPagePayments={ (filter)=> {this.props.loadPagePayments( this.props.match.params.pagename, filter )} }
                        loading_page_payments={ this.props.state.payments.loading_page_payments }
                    />
                    
                    
                </div>     
            </div>    
        )
    }
}
    
// Redux mapping
const mapStateToProps = state => {
    return {
        state
    }
}
const mapDispatchToProps = dispatch => {
    return {
        loadPagePayments:( pagename, filter ) => {
            dispatch(loadPagePayments( pagename, filter ))
        },
        changeSignUpLoginModal: ( new_state ) => {
            return dispatch( changeSignUpLoginModal( new_state ) )
        },
        changeClickType: ( click_type ) => {
            return dispatch( changeClickType( click_type ) );
        },
        setUrlRedirect: ( url_redirect ) => {
            return dispatch( setUrlRedirect( url_redirect ) );
        },
        /* changePagePaymentsLockedModalStateAction:( new_state ) => {
            dispatch(changePagePaymentsLockedModalStateAction( new_state ))
        }, */
    }
}

export default compose(
    withTranslation("payments"),
    connect(mapStateToProps, mapDispatchToProps)
)(PaymentsUnauthenticatedView);